import styles from "./bar.module.css"
import { Phone } from "../../../ui/phone/Phone"
import { Telegram } from "../../../ui/telegram/Telegram"
export function Bar() {
    return (
        <div className={styles.bar}
        >
            <div className={styles.contacts}>
                <div className={styles.contacts_icon}>
                    <Phone color={"white-sct"} />
                    <Telegram color={"white-sct"} />
                </div>
                <div className={styles.contacts_text}>
                    <div className={styles.contacts_text_item}><a href="tel:+74992882648">+7 499 288-26-48</a></div>
                    <div><a href="mailto:info@sct-germany.ru">info@sct-germany.ru</a> </div>
                </div>
            </div>

            <div className={styles.points}>
                <div className={styles.points_items} ><img src="/images/svg/warehouses.svg" alt="Розничные точки продаж" /> <p>Розничные точки продаж</p></div>
                <div className={styles.points_items} ><img src="/images/svg/diller.svg" alt="Региональные представители " /> <p>Региональные представители </p></div>
            </div>

        </div>
    )
}
